export interface SectionSeparatorProps {
  /** Visual variant: gradient (fade at ends) or filled (solid line). */
  variant?: 'gradient' | 'filled';
  /** Horizontal padding on the left (px). */
  paddingLeft?: number;
  /** Horizontal padding on the right (px). */
  paddingRight?: number;
  /** Center color of the gradient; used only when variant is "gradient". Default from design (#7DA892). */
  color?: string;
  /** Optional className for the wrapper. */
  className?: string;
}

const defaultColor = '#7DA892';

export default function SectionSeparator(props: SectionSeparatorProps) {
  const {
    variant = 'filled',
    paddingLeft = 0,
    paddingRight = 0,
    color = defaultColor,
    className = '',
  } = props;

  const hasPadding = paddingLeft !== 0 || paddingRight !== 0;
  const wrapperStyle = hasPadding
    ? { paddingLeft: `${paddingLeft}px`, paddingRight: `${paddingRight}px` }
    : undefined;

  const isFilled = variant === 'filled';

  return (
    <div className={className} style={wrapperStyle} role="separator" aria-hidden>
      {isFilled ? (
        <div className="h-px bg-pmw-separator-light dark:bg-pmw-separator-dark" />
      ) : (
        <div
          className="h-px mix-blend-luminosity"
          style={{
            background: `linear-gradient(to right, transparent, ${color}, transparent)`,
            boxShadow: '0 1px 2px rgba(0,0,0,0.06), 0 -1px 2px rgba(0,0,0,0.04)',
          }}
        />
      )}
    </div>
  );
}
